import { render } from "./ClientFooter.vue?vue&type=template&id=23c423df&scoped=true"
import script from "./ClientFooter.vue?vue&type=script&lang=js"
export * from "./ClientFooter.vue?vue&type=script&lang=js"

import "./ClientFooter.vue?vue&type=style&index=0&id=23c423df&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c423df"]])

export default __exports__